<template>
  <div  style="margin-top: 2%;" class="metricsDetail">
    <el-dialog :title="dialogTitle" :visible="isLookDetail" :close-on-click-modal ="false"  align="left" width="50%" @close="close" height="50%">
      <el-row justify="center" type="flex">
        <el-col  >
          <el-table :data="detailData">
            <el-table-column prop="name" label="Attribute"  align="left"></el-table-column>
            <el-table-column prop="value" label="Detail"  align="left"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
    export default {
        name: "metricsDetail",
        props:{
          detailData:{
            type:Array,
            default:[]
          }
        },
        data(){
          return {
            dialogTitle:"Detail",
            isLookDetail:true
          }
        },
      mounted(){
      },
      methods:{
        close:function(){
          this.$emit('close');
        }
      }
    }

</script>
<style scope>

</style>



// WEBPACK FOOTER //
// src/page/activePublic/Metrics/metricsDetail.vue